export enum ServicePortfolioType {
  Drive = 'Drive',
  Appointments = 'Appointments',
  RecentService = 'Recent Service',
}

export enum ServicePortfolioRoStatusType {
  None,
  Open,
  Closed,
}
